module.exports = __webpack_public_path__ + "static/media/deleteWarning_icon.3c7d9ece.svg";